import { render, staticRenderFns } from "./CheckboxC.vue?vue&type=template&id=bfff8e9c&scoped=true&"
import script from "./CheckboxC.vue?vue&type=script&lang=js&"
export * from "./CheckboxC.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxC.vue?vue&type=style&index=0&id=bfff8e9c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff8e9c",
  null
  
)

export default component.exports